var detail = {
	init: function(){
		commentFlick.init();
		//detailSlideshow.init();
	}
}
var commentFlick = {
	current : 0,
	max 	: 0,
	flag	: true,
	init: function(){
		var $this = commentFlick;
		$this.max = $("#detail_comment ul li").length;
		$this.current = 0;
		$this.nav();
		setTimeout(function(){
			commentFlick.toggleComment();
		},1000);
	},
	toggleComment: function(){
		var $comment = $(".detail_comment"),
			$current = $(".current_comment");
		if($comment.hasClass("disable")){
			$comment.removeClass("disable");
			$current.removeClass("disable");
		}else{
			$comment.addClass("disable");
			$current.addClass("disable");
		}
	},
	showComment: function(){
		var $comment = $(".detail_comment"),
			$current = $(".current_comment");
		if($comment.hasClass("disable")){
			$comment.removeClass("disable");
			$current.removeClass("disable");
		}
	},
	nav: function(){
		var $this = commentFlick;
		if(isSP || isIPad){
			const limit = 100;
			var lastTouchY = lastTouchY || 0,
				position,cy,touching,touchYDelta;
			$("#detail_comment").off().on({
				'touchstart': function(e) {
					cy 			= 0;
					position 	= getPosition(e);
					lastTouchY 	= position;
				},
				'touchmove': function(e) {
					e.preventDefault();
					if($this.flag){
						$this.flag = false;
					}
					var touchY 		= event.touches[0].clientY,
						touchYDelta = touchY - lastTouchY;
					cy = position - getPosition(event);
					lastTouchY 	= touchY;
				},
				'touchend': function(e) {
					if(cy < -limit){
						if($this.current <= $this.max){
							$this.dec();
						}
					}else if(cy > limit){
						$this.inc();
					}
					cy = 0;
				},
				'touchcancel': function(e){
					cy = 0;
					$this.flag 	= true;
					lastTouchY 	= 0;
				}
			});

		}else{
			var save, clock;
			/*$("body").off("mousewheel").on("mousewheel", function(e, delta,deltaX,deltaY){
				//e.preventDefault();
				if(isSmallScreen){

				}else{
					clock = e.timeStamp - save;
					save  = e.timeStamp;
					var deltaMin = 0;
					if(clock <= 300){ return false;}
					if($this.flag){
						//console.log(fromList)
						delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
						//console.log(delta)
						//if (!delta) { return;}
						if(isFF){
							deltaMin = 4;
						}else{
							deltaMin = 50;
						}
						if(delta >= 1) {
							$this.dec();
						}else if(delta < 0){
							$this.inc();
						}
					}
				}
			});
			*/
		}
		function getPosition(event){
			return event.touches[0].pageY;
		}
		$("#detail_comment_inr ul li a").off().on("click", function(){
			commentFlick.current = $("#detail_comment_inr ul li a").index(this);
			commentFlick.change();
		});
		$(".current_comment").off().on("click", function(){
			commentFlick.toggleComment();
		});
		$("a.btn_close_comment").off().on("click", function(){
			commentFlick.toggleComment();
		})
	},
	inc: function(){
		commentFlick.current++;
		if(commentFlick.current >= commentFlick.max){
			commentFlick.current = commentFlick.max-1;
		}else{
			commentFlick.change();
		}
	},
	dec: function(){
		commentFlick.current--;
		if(commentFlick.current < 0){
			commentFlick.current = 0;
		}else{
			commentFlick.change();
		}
	},
	change: function(){
		var $this = commentFlick,
			$cmt  = $("#detail_comment");
		var cls = "position" + $this.current;
		$cmt.removeClass(function(index, className) {
			return (className.match(/\bposition\S+/g) || []).join(' ');
		});
		$cmt.addClass(cls);
		this.changeComment();
		//console.log($this.current, $this.max)
	},
	changeComment: function(){
		var $this = $("#detail_comment li").eq(commentFlick.current).find("a"),
			comment = $this.attr("data-comment"),
			name 	= $this.attr("title");
		$("p.txt_comment").html(comment);
		$("p.txt_name").html("by " + name);
		commentFlick.showComment();
	}
}
var detailSlideshow = {
	current : 0,
	max 	: 0,
	maxNum 	: 0,
	posCount: 0,
	flag : true,
	isSlide : false,
	videos: [],
	init: function(){
		var d = detailSlideshow;
		d.max 		= $("ul.list_detail_imgs li").length;
		d.maxNum 	= detailSlideshow.max - 1;
		d.posCount 	= 0;
		if(d.max < 5){
			$("a.btn_prev").remove();
			$("a.btn_next").remove();
			d.checkSlideNav();
		}else{
			d.pagerMax 	= Math.ceil(d.max / 4);
			d.isSlide 	= true;
			var beforeHTML = '';
			var afterHTML = '';
			for(var i = 0; i < 4; i++){
				beforeHTML += '<li class="clone1">' + $(".detail_list_nav ul li").eq(i).html() + '</li>';
				afterHTML += '<li class="clone0">' + $(".detail_list_nav ul li").eq(d.max - 4 + i).html() + '</li>';
			}
			$(".detail_list_nav ul").prepend(afterHTML);
			$(".detail_list_nav ul").append(beforeHTML);
			d.checkSlideNav();
		}
		var count = -4
		$(".detail_list_nav ul li").each(function(){
			$(this).find("a").attr("data-num", count);
			count++;
		})
		//詳細画像
		var detailBefore 	= '<li class="clone">' + $("#detail_img ul.list_detail_imgs li").eq(0).html() + '</li>';
		var detailBefore02 	= '<li class="clone">' + $("#detail_img ul.list_detail_imgs li").eq(1).html() + '</li>';
		var detailBefore03 	= '<li class="clone">' + $("#detail_img ul.list_detail_imgs li").eq(2).html() + '</li>';
		var detailAfter		= '<li class="clone">' + $("#detail_img ul.list_detail_imgs li").eq($("#detail_img ul.list_detail_imgs li").length - 1).html() + '</li>';
		var detailAfter02	= '<li class="clone">' + $("#detail_img ul.list_detail_imgs li").eq($("#detail_img ul.list_detail_imgs li").length - 2).html() + '</li>';
		$("#detail_img ul.list_detail_imgs").prepend(detailAfter);
		$("#detail_img ul.list_detail_imgs").append(detailBefore);
		$("#detail_img ul.list_detail_imgs").append(detailBefore02);
		$("#detail_img ul.list_detail_imgs").append(detailBefore03);
		d.videos = [];
		$(".video").each(function(i){
			var $video = $(this).find("video").get(0);
			d.videos.push($video);
		});
		this.nav();
	},
	checkSlideNav: function(){
		var _x 	= $(".detail_list_nav li").width();
		var _mpx = String($(".detail_list_nav li:eq(0)").css("margin-right"));
		var _m = _mpx.replace("px", "");

		var count = 0;
		var minus = 0;
		if(detailSlideshow.isSlide){
			minus = 4;
		}else{
			minus = 0;
		}
		$(".detail_list_nav ul li").each(function(i){
			var n = i - minus;
			var _l = _x*n + _m*n;
			$(this).css({
				"left": _l + "px"
			});
		});
	},
	nav: function(){
		var d = detailSlideshow;
		$(".detail_list_nav li a").off().on("click", function(){
			var $this = this;
			$(".detail_list_nav li a").removeClass("active");
			$($this).addClass("active");

			if(!d.isSlide){
				var idx = $(".detail_list_nav li a").index($this);
				d.current = idx;
				d.posCount = $(".detail_list_nav li a").index($this);
				d.change();
			}else{
				//SP
				var idx = parseInt($($this).attr("data-num"));
				
				var num = idx - d.current;
				//d.posCount = $(".detail_list_nav li a").index($this) - 4;
				console.log("num:", num);
				d.inc(num)
			}
		});
		const limit = 100;
		var lastTouchX = lastTouchX || 0,
			position,cx,touching,touchXDelta;
		
		$("#detail_img").off().on({
			'touchstart': function(e) {
				cx 			= 0;
				position 	= getPosition(e);
				lastTouchX 	= position;
			},
			'touchmove': function(e) {
				var touchX 		= event.touches[0].clientX,
					touchXDelta = touchX - lastTouchX;
				cx = position - getPosition(event);
				lastTouchX 	= touchX;
			},
			'touchend': function(e) {
				if(cx < -limit){
					detailSlideshow.dec(1);
				}else if(cx > limit){
					detailSlideshow.inc(1);
				}
				cx = 0;
			},
			'touchcancel': function(e){
				cx = 0;
				detailSlideshow.flag 	= true;
				lastTouchX 	= 0;
			}
		});
		function getPosition(event){
			return event.touches[0].pageX;
		}
		$("a.btn_prev").off().on("click", function(){
			detailSlideshow.dec(1);
		});
		$("a.btn_next").off().on("click", function(){
			detailSlideshow.inc(1);
		});
		$("a.btn_playvideo").off().on("click", function(){
			var idx = $("a.btn_playvideo").index(this);
			var $thisVideo = $(".video").eq(idx);
			if(!$thisVideo.hasClass("playing")){
				$(".video").eq(idx).addClass("playing");
				d.videos[idx].play();
				d.videos[idx].addEventListener('ended', function() {
					$(".video").eq(idx).removeClass("playing");
					d.videos[idx].pause();
				}, false);
			}else{
				$(".video").eq(idx).removeClass("playing");
				d.videos[idx].pause();
			}
			//console.log(d.videos[idx],idx);
		});
	},
	inc: function(num){
		var d = detailSlideshow;
		if(d.flag){
			d.flag = false;
			d.current 	= d.current+num;
			d.posCount 	= d.posCount+num;
			if(isSmallScreen){
				if(d.current >= d.max){
					d.current = 0;
				}
			}
			d.change();
		}
	},
	dec: function(num){
		var d = detailSlideshow;
		if(d.flag){
			d.current 	= d.current-num;
			d.posCount 	= d.posCount-num;
			if(isSmallScreen){
				if(d.current < 0){
					d.current = d.max -1;
				}
			}
			d.change();
		}
	},
	change: function(){
		var d = detailSlideshow;
		console.log(d.current, d.max)
		d.checkVideo();
		$("ul.list_detail_imgs li").removeClass("active");
		$("ul.list_detail_imgs li").eq(d.current+1).addClass("active");
		$(".detail_list_nav li a").removeClass("active");
		var cloneLen = $(".clone0").length;
		
		if(isSmallScreen){
			if(cloneLen){
				$(".detail_list_nav li a").eq(d.current + cloneLen).addClass("active");
			}else{
				$(".detail_list_nav li a").eq(d.current).addClass("active");
			}
		}
		
		//ページャー移動
		var _x 	= $(".detail_list_nav li").width();
		var _mpx = String($(".detail_list_nav li:eq(0)").css("margin-right"));
		var _m = _mpx.replace("px", "");

		if(isSmallScreen || !d.isSlide){
			$(".detail_list_nav ul").css({
				"transform" : "translate3d(0px, 0,0)"
			});
			setTimeout(function(){
				d.flag = true;
			},600);
		}else{
			$(".detail_list_nav ul").css({
				"transform" : "translate3d(" + (_x*-d.posCount - _m*d.posCount) + "px, 0,0)"
			});
		}
		//移動終了後
		$(".detail_list_nav ul").off().on(transitionend, function(){
			
		})
		setTimeout(function(){
			$(".detail_list_nav ul").off();
			
			if(d.posCount >= d.max){
				var diff = d.posCount - d.max;
				d.posCount 	= diff;
				d.current 	= diff;
				
			}else if(d.posCount < 0){
				var diff =  d.max - Math.abs(d.posCount);
				d.posCount 	= diff;
				d.current 	= diff;
			}

			$(".detail_list_nav ul").addClass("notransition");
			if(isSmallScreen || !d.isSlide){
				$(".detail_list_nav ul").css({
					"transform" : "translate3d(0px, 0,0)"
				});
			}else{
				$(".detail_list_nav ul").css({
					"transform" : "translate3d(" + (_x*-d.posCount - _m*d.posCount) + "px, 0,0)"
				});
			}
			setTimeout(function(){
				$(".detail_list_nav ul").removeClass("notransition");
				d.flag = true;
			},200);
		},600)
	},
	checkVideo: function(){
		$(".video").each(function(i){
			var $this = $(this);
			if($this.hasClass("playing")){
				$this.removeClass("playing");
				detailSlideshow.videos[i].pause();
			}
		});
	}
}